/* eslint-disable import/prefer-default-export */
import axios from 'axios';

export const fetchItem = ({
  handle, measurements, sortIndex, shippingRegion,
}) => (dispatch) => {
  const api = `/products/${handle}.js`;

  return axios.get(api)
    .then((res) => {
      dispatch({
        type: 'RECEIVE_UPSELL_ITEM',
        item: {
          ...res.data,
          measurements,
          sortIndex,
          shippingRegion,
        },
      });
    })
    .catch((error) => {
      // eslint-disable-next-line no-console
      console.log(error);
      if (error.response && error.response.data) {
        dispatch({
          type: 'RECEIVE_UPSELL_ITEMS_ERROR',
          error: error.response.data.description,
        });
      }
    });
};
